module.exports = __webpack_public_path__ + "img/sikeres.99c2d596.png";